import redDie from "./assets/red-die.svg";
import blueDie from "./assets/blue-die.svg";
import greenDie from "./assets/green-die.svg";
import yellowDie from "./assets/yellow-die.svg";
import whiteDie from "./assets/white-die.svg";
import white6 from "./assets/white-6.svg";
import white5 from "./assets/white-5.svg";
import white4 from "./assets/white-4.svg";
import white3 from "./assets/white-3.svg";
import white2 from "./assets/white-2.svg";
import white1 from "./assets/white-1.svg";
import black6 from "./assets/black-6.svg";
import black5 from "./assets/black-5.svg";
import black4 from "./assets/black-4.svg";
import black3 from "./assets/black-3.svg";
import black2 from "./assets/black-2.svg";
import black1 from "./assets/black-1.svg";
import unknownNumber from "./assets/white-unknown.svg";
import unknownDie from "./assets/unknown-die.svg";
import "./Die.css";

import { useState, useEffect, useRef } from "react";
import classnames from "classnames";

type DieProps = {
  number: number;
  color: string;
};

function numberToImg(number: number, isWhite: boolean): string {
  switch (number) {
    case 1:
      return isWhite ? white1 : black1;
    case 2:
      return isWhite ? white2 : black2;
    case 3:
      return isWhite ? white3 : black3;
    case 4:
      return isWhite ? white4 : black4;
    case 5:
      return isWhite ? white5 : black5;
    case 6:
      return isWhite ? white6 : black6;
    default:
      return unknownNumber;
  }
}

function colorToImage(color: string): [string, boolean] {
  switch (color) {
    case "red":
      return [redDie, true];
    case "blue":
      return [blueDie, true];
    case "green":
      return [greenDie, true];
    case "yellow":
      return [yellowDie, true];
    case "white":
      return [whiteDie, false];
    default:
      return [unknownDie, true];
  }
}

function getDieNumber(): number {
  return Math.floor(Math.random() * 6) + 1;
}

const spinDuration = 1250;
const numberDuration = 100;

function Die({ number, color }: DieProps) {
  const [isSpinning, setIsSpinning] = useState(true);
  const [displayNumber, setDisplayNumber] = useState(number);
  const [dieImg, isWhite] = colorToImage(color);
  const isSpinningRef = useRef(isSpinning);
  isSpinningRef.current = isSpinning;

  const changeToRandomNumber = () => {
    if (isSpinningRef.current) {
      setDisplayNumber(getDieNumber());
      setTimeout(changeToRandomNumber, numberDuration);
    } else {
      setDisplayNumber(number);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      setIsSpinning(false);
    }, spinDuration);
  }, []);

  useEffect(() => {
    changeToRandomNumber();
  }, []);

  const numberImg = numberToImg(displayNumber, isWhite);
  const dieBodyClasses = classnames("dieBody", { spinning: isSpinning });

  return (
    <div className="dieContainer">
      <img src={dieImg} className={dieBodyClasses} />
      <img src={numberImg} className="dieNumber" />
    </div>
  );
}

export default Die;
